import { SocialPlatform } from 'types/interfaces/socialLinks';
import { IconPrefix, IconName } from '@fortawesome/fontawesome-svg-core';

const DOMAIN_TO_PLATFORM: Array<[string[], SocialPlatform]> = [
  [['twitter.com', 'x.com'], 'twitter'],
  [['discord.gg', 'discord.com'], 'discord'],
  [['instagram.com'], 'instagram'],
  [['facebook.com', 'fb.com'], 'facebook'],
  [['youtube.com', 'youtu.be'], 'youtube'],
  [['twitch.tv'], 'twitch'],
  [['reddit.com'], 'reddit'],
  [['github.com'], 'github'],
  [['linkedin.com'], 'linkedin'],
  [['tiktok.com'], 'tiktok'],
  [['moxfield.com'], 'moxfield'],
  [['archidekt.com'], 'archidekt'],
  [['deckbox.org'], 'deckbox'],
  [['cardsphere.com'], 'cardsphere'],
  [['tcgplayer.com'], 'tcgplayer'],
];

export function detectPlatform(url: string): SocialPlatform {
  try {
    const hostname = new URL(url).hostname.toLowerCase().replace(/^www\./, '');
    for (const [domains, platform] of DOMAIN_TO_PLATFORM) {
      if (domains.some((d) => hostname === d || hostname.endsWith(`.${d}`))) {
        return platform;
      }
    }
  } catch {
    // Invalid URL
  }
  return 'other';
}

export const PLATFORM_ICON_MAP: Record<SocialPlatform, [IconPrefix, IconName]> = {
  twitter: ['fab', 'x-twitter'],
  discord: ['fab', 'discord'],
  instagram: ['fab', 'instagram'],
  facebook: ['fab', 'facebook'],
  youtube: ['fab', 'youtube'],
  twitch: ['fab', 'twitch'],
  reddit: ['fab', 'reddit'],
  github: ['fab', 'github'],
  linkedin: ['fab', 'linkedin'],
  tiktok: ['fab', 'tiktok'],
  moxfield: ['fas', 'link'],
  archidekt: ['fas', 'link'],
  deckbox: ['fas', 'link'],
  cardsphere: ['fas', 'link'],
  tcgplayer: ['fas', 'link'],
  other: ['fas', 'link'],
};

export const PLATFORM_LABEL_MAP: Record<SocialPlatform, string> = {
  twitter: 'X (Twitter)',
  discord: 'Discord',
  instagram: 'Instagram',
  facebook: 'Facebook',
  youtube: 'YouTube',
  twitch: 'Twitch',
  reddit: 'Reddit',
  github: 'GitHub',
  linkedin: 'LinkedIn',
  tiktok: 'TikTok',
  moxfield: 'Moxfield',
  archidekt: 'Archidekt',
  deckbox: 'Deckbox',
  cardsphere: 'Cardsphere',
  tcgplayer: 'TCGplayer',
  other: 'Link',
};
